import {AuthService, CurrentUser} from 'app/core/services/auth.service';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {EnvName, getEnvName} from '../../../environments/env-name';
import Mixpanel from 'mixpanel-browser';

declare global {
    interface Window {
        mixpanel: typeof Mixpanel;
    }
}

@Injectable()
export class MixpanelService {
    constructor(private auth: AuthService) {}

    private isInited = false;

    init(): void {
        if (this.isDisabled()) {
            console.debug('mixpanel.init');
            return;
        }

        this.auth
            .getCurrentUserWithoutRoles() // we don't need to track users with system roles
            .then((user: CurrentUser) => {
                Mixpanel.init(environment.mixpanelTracking, {ignore_dnt: true});
                window.mixpanel = Mixpanel;
                this.isInited = true;
                Mixpanel.identify(user.id);
            });
    }

    track(eventName: string, properties?: any): void {
        if (!properties || typeof properties !== 'object') {
            properties = {};
        }
        if (this.auth.getCurrentUserLastValue()) {
            properties.rank = this.auth.getCurrentUserLastValue().rank;
        }
        if (this.isDisabled() || !this.isInited) {
            console.debug(`mixpanel.track: '${eventName}', properties: ${JSON.stringify(properties)}`);
            return;
        }

        Mixpanel.track(eventName, properties);
    }

    private isDisabled(): boolean {
        return getEnvName() !== EnvName.Prod || !environment.mixpanelTracking;
    }
}
